import { OperatorFunction } from 'rxjs';
import { isOfType } from './is-of-type';

export function isInstanceOf<TIn, TOut extends TIn>(
  c: new (...args: any[]) => TOut,
): OperatorFunction<TIn, TOut> {
  return isOfType(((v: TIn) => v instanceof c) as (v: TIn) => v is TOut);
}
